import { MooringDepartureData } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const dataTag = 'MooringDepartureData';
export default class MooringDepartureParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.MOORING_DEPARTURE, FIXED_PROTOCOL_CONTENT_TYPE_IDS.MOORING_DEPARTURE, dataTag, app);
    }
    getPropsMapping() {
        return {
            port: 'port',
            freeText: 'freeText',
        };
    }
    createData(props, record) {
        const data = new MooringDepartureData(props.port, props.freeText);
        const linked = this.getLinked(record);
        if (linked) {
            const link = {
                protocol: linked,
                value: props.port,
            };
            data.port = link;
        }
        return data;
    }
}
//# sourceMappingURL=MooringDepartureParser.js.map